import { theme } from '@garnish/constants';

// ─── Bottom Sheet ────────────────────────────────────────────────────────────

export const BOTTOM_SHEET_TOP_HANDLER_HEIGHT = 32;
export const BOTTOM_SHEET_TOP_HANDLER_PLACEHOLDER_HEIGHT = theme.spacing['4'];
export const BOTTOM_SHEET_SHADOW_HEIGHT = 12;
export const BOTTOM_SHEET_SHADOW_TOP_POSITION = -BOTTOM_SHEET_SHADOW_HEIGHT;
export const BOTTOM_SHEET_SHADOW_OFFSET = BOTTOM_SHEET_SHADOW_HEIGHT / 2;
